export const iconFontAwesomeReligionPersonPraying = (
	<i className="fa-solid fa-person-praying"></i>
);
